<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>订单统计</span>
        </div>
        <el-form :inline="true">
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="queryParams.startDate"
              placeholder="请选择日期"
              clearable
              value-format="yyyy-MM-dd"
              type="date"
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker
              v-model="queryParams.endDate"
              placeholder="请选择日期"
              clearable
              value-format="yyyy-MM-dd"
              type="date"
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
          />
          <el-table-column
            prop="total_price"
            label="总充值"
            width="200"
            :formatter="priceFormatter"
          />
          <el-table-column
            label="总下单数"
            prop="total_order"
          />
          <el-table-column
            prop="succ_order"
            label="成功订单数"
          />
          <el-table-column
            prop="successRate"
            label="成功率"
            :formatter="successRateFormatter"
          />
          <el-table-column
            prop="cancel_order"
            label="取消订单数"
          />
          <el-table-column
            prop="failureRate"
            label="取消率"
            :formatter="failureRateFormatter"
          />
          <el-table-column
            prop="month_on_month"
            label="环比"
            :formatter="monthRateFormatter"
          />
          <el-table-column
            prop="year_on_year"
            label="同比"
            :formatter="yearRateFormatter"
          />
        </el-table>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getOrderStatistsList } from '@/api/config/order'
export default {
  name: 'Statistics',
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      },
      total: 0,
      tableData: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
      }
      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
      }
      this.getTables()
    },
    getTables() {
      getOrderStatistsList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    }, priceFormatter(row, col) {
      return '$' + row.total_price
    }, successRateFormatter(row, col) {
      return row.successRate + '%'
    }, failureRateFormatter(row, col) {
      return row.failureRate + '%'
    }, monthRateFormatter(row, col) {
      return row.month_on_month + '%'
    }, yearRateFormatter(row, col) {
      return row.year_on_year + '%'
    }
  }
}
</script>

<style scoped>
</style>
